/**
 * Built-in request statuses (fallback order). Live options come from the backend
 * status config — use getRequestStatusDropdownOptions / useRequestStatusConfig.
 */
export const INVENTORY_REQUEST_STATUSES = [
  'NEW_REQUEST',
  'REQ_TO_VERIFY',
  'APPROVED',
  'IN_CART',
  'ON_HOLD',
  'REJECTED',
  'ORDERED',
  'DELIVERED',
  'EXCEPTION',
] as const;

export type InventoryRequestStatus = (typeof INVENTORY_REQUEST_STATUSES)[number];

/** Re-export shipment tracking statuses (inventory_request.data.shipment_status). */
export {
  SHIPMENT_STATUSES,
  DEFAULT_SHIPMENT_STATUS,
  type ShipmentStatus,
} from '@/lib/inventory/shipmentTracking';

/** Canonical inventory item statuses for dropdowns and filters. */
export const INVENTORY_ITEM_STATUSES = [
  'IN_STOCK',
  'OUT_OF_STOCK',
  'RESERVED',
  'DISCONTINUED',
  'ON_ORDER',
] as const;

/** Allowed status options per entity type (for status dropdown in record modals etc.). */
export const ALLOWED_STATUSES: Record<string, readonly string[]> = {
  inventory_item: INVENTORY_ITEM_STATUSES,
  inventory_request: INVENTORY_REQUEST_STATUSES,
  unmannd_request: INVENTORY_REQUEST_STATUSES,
};
